/**
 * Tracks a guest "Sign up" button click via sendBeacon, then redirects to Auth0.
 * sendBeacon is fire-and-forget — it survives page navigation.
 */
export function trackSignupAndRedirect(
  pathname: string,
  source: string,
  companyId?: string,
) {
  try {
    navigator.sendBeacon(
      '/api/auth/signup-click',
      new Blob([JSON.stringify({ source, companyId, pathname })], {
        type: 'application/json',
      }),
    );
  } catch {
    // Silently ignore — tracking must never block navigation
  }
  window.location.href = `/auth/login?returnTo=${encodeURIComponent(pathname)}`;
}
